export default __webpack_public_path__ + "static/img3-d27c05eae37df6e2423fa59a27fbe601.png";